/**
 * Default history window for the records loaded at login (eggs, feed, mortality, sales, expenses).
 * Older records are fetched on demand (see AppContext.ensureHistory) when a page asks for a
 * date range that starts before the window.
 */
export const HISTORY_DAYS = 90;

/** Local-date YYYY-MM-DD for `days` ago (never use toISOString — it shifts the date for UTC+ users). */
export function daysAgoStr(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** First date (inclusive) of the default window. */
export const historyStart = () => daysAgoStr(HISTORY_DAYS);

/**
 * Lifetime record count for plan-limit usage. The list in state only holds the loaded window, so
 * add the change since load to the server's lifetime total (falls back to the list length).
 */
export function recordCount(state, key) {
  const len = state?.[key]?.length ?? 0;
  const u = state?.usage;
  if (!u || u.base?.[key] == null || u.loaded?.[key] == null) return len;
  return Math.max(0, u.base[key] + (len - u.loaded[key]));
}
